import { useDeleteUserHomeToken } from "src/data/homes/queries/homeTokenQueries"
import { THomeToken } from "src/data/homes/types/homeTokenTypes"
import { MDialog } from "src/ui/Dialog/MDialog"
import { MText } from "src/ui/MText"
import { formatUtcDate } from "src/utils/l10n"

export function ParadiseUserDeleteHomeTokenDialog({
  userId,
  open,
  onClose,
  token,
}: {
  userId: string
  open: boolean
  onClose: () => void
  token: THomeToken
}) {
  const deleteUserHomeToken = useDeleteUserHomeToken()

  function handleDelete() {
    deleteUserHomeToken.mutate({
      userId,
      tokenId: token.id ?? "",
      create_refund: false, // this field is not used in the backend
    })
  }

  return (
    <MDialog
      title="Delete home token?"
      open={open}
      onClose={onClose}
      onConfirm={() => {
        handleDelete()
        onClose()
      }}
      confirmLabel="Delete"
      confirmButtonProps={{
        color: "destructive",
      }}
    >
      <MText variant="body">
        Are you sure you want to delete this home token?
      </MText>
      <MText variant="subtitleS">Token details:</MText>
      <MText variant="bodyS">• ID: {token.id}</MText>
      <MText variant="bodyS">
        • Created at: {formatUtcDate({ date: token.created_at })}
      </MText>
      <MText variant="bodyS">
        • Expires at: {formatUtcDate({ date: token.expires_at })}
      </MText>
      {token.amount_paid > 0 && (
        <MText variant="bodyS">
          • Cost: {token.amount_paid / 100} {token.currency}
        </MText>
      )}
      <MText variant="body">This action cannot be undone.</MText>
    </MDialog>
  )
}
